import type { QueryResult } from '@apollo/client';
import { useQuery } from '@apollo/client';
import Cookie from 'js-cookie';

import type { AdTypes } from '@xing-com/crate-common-graphql-types';

import type { AdAuctionWinnersQuery } from '../auction-ads.gql-types';
import { AdAuctionWinnersDocument } from '../auction-ads.gql-types';

export type AdSettings = {
  adCount: number;
  adTypes: AdTypes[];
  channel: string;
  isLoggedOut?: boolean;
  skipQuery?: boolean;
};

export const useAdsNetwork = (
  settings: AdSettings
): QueryResult<AdAuctionWinnersQuery, Record<string, unknown>> & {
  isSkipped: boolean;
} => {
  const { isLoggedOut, skipQuery, ...auctionSettings } = settings;
  const scrambledId = Cookie.get('s_id2');

  // Prevent delivery of ads in case we can't identify the logged out user.
  const skipLoggedOutQuery = isLoggedOut && !scrambledId;
  const addScrambledId = isLoggedOut && scrambledId;
  const isSkipped = Boolean(skipQuery || skipLoggedOutQuery);

  const query = useQuery<AdAuctionWinnersQuery>(AdAuctionWinnersDocument, {
    variables: {
      auctionWinnersInput: {
        ...auctionSettings,
        ...(addScrambledId && { scrambledId }),
      },
    },
    fetchPolicy: 'network-only',
    skip: isSkipped,
  });

  return { ...query, isSkipped };
};
